import React from "react";
import { injectIntl } from "react-intl";
import { useSelector } from "react-redux";
import { CheckOutlined, ClockCircleOutlined } from "@ant-design/icons";
import {
  LEGENDA,
  NON_INIZIATO_LABEL,
  IN_CORSO_LABEL,
  CONCLUSO_LABEL,
  LAST_UPDATE_LABEL,
} from "../../../modules/language";
import { getLastUpdateInfo } from "../../../modules/surgery";
import { getMessageString } from "../../../tools";

const LegendaBase = ({ intl }) => {
  const lastUpdate = useSelector(getLastUpdateInfo);
  return (
    <div className="legenda">
      {lastUpdate && (
        <div className="lastUpdateInfo">
          <span className="corsivo">{getMessageString(intl, LAST_UPDATE_LABEL)}</span>
          <span className="update">{lastUpdate}</span>
        </div>
      )}
      <span className="itemLabel">{getMessageString(intl, LEGENDA)}</span>
      <div className="legendaLabels">
        <div className="legendaLabel">
          <div id="nonIniziato" className="dotLegenda nonIniziato" />
          <span className="descrizione">{getMessageString(intl, NON_INIZIATO_LABEL)}</span>
        </div>
        <div className="legendaLabel">
          <ClockCircleOutlined id="inCorso" />
          <span className="descrizione">{getMessageString(intl, IN_CORSO_LABEL)}</span>
        </div>
        <div className="legendaLabel">
          <CheckOutlined id="concluso"/>
          <span className="descrizione">{getMessageString(intl, CONCLUSO_LABEL)}</span>
        </div>
      </div>
    </div>
  );
};
export const Legenda = injectIntl(LegendaBase);
